import { postJSON } from 'common/services/api'
import {
  EDIT_TRAVEL_INFO_QUERY_KEY,
  EDIT_TRAVEL_INFO_URL,
  REVISIONS_QUERY_KEY,
  REVISION_QUERY_KEY,
} from './queryConstants'
import { useMutation, useQueryClient } from 'react-query'
import { TravelMode } from '../types'

type UseEditTravelInfoReturn = {
  editTravelInfo: (values: EditTravelInfoPayload) => Promise<unknown>
  isEditTravelInfo: boolean
}

export type UseEditTravelInfoProps = {
  instanceId: string
}

type EditTravelInfoPayload = {
  teamMemberId: string
  role: string
  travelDistance?: number
  travelTime?: number
  travelMode?: TravelMode
}

const useEditTravelInfo = ({
  instanceId,
}: UseEditTravelInfoProps): UseEditTravelInfoReturn => {
  const queryClient = useQueryClient()

  const editTravelInfoFunction = async (
    values: EditTravelInfoPayload
  ): Promise<unknown> => {
    return postJSON({
      url: `${EDIT_TRAVEL_INFO_URL}/${instanceId}`,
      method: 'PUT',
      json: values,
      isRota: true,
    })
  }

  const { mutateAsync: editTravelInfoMutation, isLoading: isEditTravelInfo } =
    useMutation<unknown, unknown, EditTravelInfoPayload, unknown>(
      [EDIT_TRAVEL_INFO_QUERY_KEY],
      editTravelInfoFunction,
      {
        onSuccess: () => {
          queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
          queryClient.invalidateQueries([REVISION_QUERY_KEY])
        },
      }
    )

  const handleEditTravelInfo = async (values: EditTravelInfoPayload) => {
    try {
      const result = await editTravelInfoMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    editTravelInfo: handleEditTravelInfo,
    isEditTravelInfo,
  }
}

export default useEditTravelInfo
